import React from 'react'
import './PrivacyPolicyPage.css'

function PrivacyPolicyPage() {
  return (
    <div className="privacy-page">
      <div className="privacy-hero">
        <div className="container">
          <h1>Privacy Policy</h1>
          <p>How MoRecharz collects, uses, and protects your information</p>
        </div>
      </div>

      <div className="container">
        <div className="privacy-content">
          <section className="privacy-section">
            <h2>1. Introduction</h2>
            <p>
              MoRecharz is committed to protecting your privacy. This Privacy Policy explains how we collect,
              use, disclose, and safeguard your information when you use our mobile recharge services.
            </p>
          </section>

          <section className="privacy-section">
            <h2>2. Information We Collect</h2>
            <p>We may collect the following categories of information:</p>
            <ul>
              <li>Personal details such as name, phone number, and email address</li>
              <li>Recharge transaction details including operator, amount, and time</li>
              <li>Payment metadata and transaction reference numbers from payment gateways</li>
              <li>Device and usage information such as IP address, browser type, and pages visited</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>3. How We Use Your Information</h2>
            <p>Your information may be used to:</p>
            <ul>
              <li>Process recharge requests and complete transactions</li>
              <li>Provide customer support and resolve complaints</li>
              <li>Send recharge alerts, order updates, and service notifications</li>
              <li>Improve platform performance, reliability, and user experience</li>
              <li>Prevent fraud, abuse, and unauthorized access</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>4. Payment Information</h2>
            <p>
              Payments are processed via trusted payment gateway partners such as PayU. MoRecharz does not store
              full card details or confidential payment credentials on its servers. Payment handling is subject to
              the applicable security and compliance policies of the gateway provider.
            </p>
          </section>

          <section className="privacy-section">
            <h2>5. Cookies and Tracking</h2>
            <p>
              We may use cookies and similar technologies for session management, analytics, and improving service
              quality. You can manage cookie preferences through your browser settings.
            </p>
          </section>

          <section className="privacy-section">
            <h2>6. Data Sharing and Disclosure</h2>
            <p>We may share data only when necessary, including:</p>
            <ul>
              <li>With telecom operators and payment partners to complete recharge transactions</li>
              <li>With service providers who help us operate and maintain the platform</li>
              <li>When required by law, regulation, legal process, or government request</li>
              <li>To protect rights, security, and prevent fraudulent or illegal activity</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>7. Data Retention</h2>
            <p>
              We retain personal and transaction data only for as long as needed for operational, legal, and
              compliance purposes. Data no longer required is securely deleted or anonymized.
            </p>
          </section>

          <section className="privacy-section">
            <h2>8. Data Security</h2>
            <p>
              We use reasonable technical and organizational safeguards to protect your information against
              unauthorized access, alteration, disclosure, or destruction. However, no online system can be
              guaranteed 100% secure.
            </p>
          </section>

          <section className="privacy-section">
            <h2>9. Your Rights</h2>
            <p>Subject to applicable law, you may request to:</p>
            <ul>
              <li>Access or correct your personal information</li>
              <li>Delete your account and associated data, where permissible</li>
              <li>Withdraw consent for certain communications</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>10. Third-Party Links</h2>
            <p>
              Our platform may include links to third-party websites. We are not responsible for their privacy
              practices and encourage users to review external privacy policies independently.
            </p>
          </section>

          <section className="privacy-section">
            <h2>11. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. Any changes will be posted on this page with
              a revised effective date.
            </p>
          </section>

          <section className="privacy-section">
            <h2>12. Contact Us</h2>
            <p>
              For privacy-related questions or requests, contact us at:
            </p>
            <p>
              <strong>Email:</strong> <a href="mailto:support@morecharz.com">support@morecharz.com</a>
            </p>
          </section>

          <section className="privacy-section last-updated">
            <p><em>Last Updated: June 2026</em></p>
          </section>
        </div>
      </div>
    </div>
  )
}

export default PrivacyPolicyPage
